var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"edit-pencil-btn",attrs:{"aria-label":_vm.editInfoText},on:{"click":_vm.edit}})}
var staticRenderFns = []

export { render, staticRenderFns }